var _path, _path2, _g, _path3, _path4, _path5, _g2, _path6, _path7, _g3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBooking = function SvgBooking(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 176 30"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#booking_svg__a)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "booking_svg__b",
    width: 176,
    height: 31,
    x: 0,
    y: -1,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.37-.215h175.297v29.88H.371z"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#booking_svg__b)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "booking_svg__c",
    width: 176,
    height: 31,
    x: 0,
    y: -1,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.37 29.666h175.297V-.215H.371z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#booking_svg__c)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#273B7D",
    d: "M69.114 3.056c0-1.484 1.191-2.683 2.658-2.683 1.472 0 2.669 1.2 2.669 2.683a2.676 2.676 0 0 1-2.669 2.682c-1.467 0-2.658-1.201-2.658-2.682"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#499FDD",
    d: "M111.142 20.9c0-1.483 1.191-2.684 2.658-2.684a2.677 2.677 0 0 1 2.667 2.685 2.677 2.677 0 0 1-2.667 2.682c-1.467 0-2.658-1.202-2.658-2.682"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#273B7D",
    d: "M25.398 19.741c-2.294 0-3.889-1.83-3.889-4.446s1.595-4.444 3.889-4.444c2.307 0 3.919 1.83 3.919 4.444 0 2.657-1.579 4.446-3.92 4.446m0-12.797c-4.854 0-8.376 3.513-8.376 8.351s3.522 8.351 8.376 8.351c4.871 0 8.408-3.513 8.408-8.35 0-4.839-3.537-8.352-8.408-8.352M63.955 15.713a4 4 0 0 0-.635-.898l-.147-.157.154-.149a7 7 0 0 0 .67-.84l4.284-6.396h-5.2l-3.218 5.004q-.274.402-1.1.403h-.734V3.22c0-1.891-1.173-2.149-2.44-2.149h-2.17l.003 22.329h4.607v-6.698h.432c.525 0 .883.061 1.047.348l2.541 4.819c.71 1.308 1.418 1.53 2.748 1.53h3.531l-2.63-4.369zM86.32 6.908c-2.343 0-3.838 1.046-4.676 1.93l-.28.284-.098-.386c-.247-.947-1.076-1.469-2.325-1.469h-2.065l.013 16.127h4.576v-7.433c0-.726.094-1.357.285-1.932.51-1.742 1.93-2.824 3.706-2.824 1.429 0 1.987.757 1.987 2.714v7.023c0 1.67.769 2.452 2.432 2.452h2.178l-.007-10.257c0-4.075-1.98-6.229-5.725-6.229M71.833 7.275h-2.168l.014 12.469-.001 3.654h2.315c.029 0 .052.003.082.003l1.078-.003h1.073v-.006h.008l.009-13.669c0-1.65-.786-2.448-2.41-2.448M43.37 19.741c-2.293 0-3.89-1.83-3.89-4.446s1.597-4.444 3.89-4.444c2.303 0 3.919 1.83 3.919 4.444 0 2.657-1.578 4.446-3.919 4.446m0-12.797c-4.858 0-8.38 3.513-8.38 8.351s3.522 8.351 8.38 8.351c4.867 0 8.41-3.513 8.41-8.35 0-4.839-3.543-8.352-8.41-8.352"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "booking_svg__d",
    width: 176,
    height: 31,
    x: 0,
    y: -1,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.37-.215h175.297v29.88H.371z"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#booking_svg__d)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "booking_svg__e",
    width: 176,
    height: 30,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.37.373h175.26v29.254H.37z"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#booking_svg__e)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "booking_svg__f",
    width: 176,
    height: 31,
    x: 0,
    y: -1,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.37 29.666h175.297V-.215H.371z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#booking_svg__f)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#499FDD",
    d: "M141.452 19.742c-2.293 0-3.892-1.83-3.892-4.446s1.599-4.444 3.892-4.444c2.303 0 3.92 1.829 3.92 4.444 0 2.657-1.579 4.446-3.92 4.446m0-12.798c-4.857 0-8.38 3.514-8.38 8.352s3.523 8.35 8.38 8.35c4.867 0 8.409-3.512 8.409-8.35s-3.542-8.352-8.409-8.352"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#273B7D",
    d: "M101.694 19.032c-2.502 0-3.392-2.193-3.392-4.248 0-.905.227-3.856 3.151-3.856 1.453 0 3.39.419 3.39 4.008 0 3.386-1.714 4.096-3.149 4.096m5.524-11.8c-.868 0-1.536.347-1.871.982l-.127.247-.212-.185c-.738-.642-2.062-1.404-4.213-1.404-4.279 0-7.16 3.229-7.16 8.033 0 4.799 2.981 8.153 7.246 8.153 1.457 0 2.608-.342 3.521-1.036l.353-.266v.448c0 2.154-1.387 3.342-3.9 3.342-1.222 0-2.334-.299-3.077-.57-.971-.294-1.54-.05-1.934.928l-.363.903-.514 1.318.319.17c1.608.858 3.702 1.37 5.595 1.37 3.897 0 8.447-2.004 8.447-7.643l.017-14.79z"
  }))))), /*#__PURE__*/React.createElement("mask", {
    id: "booking_svg__g",
    width: 176,
    height: 31,
    x: 0,
    y: -1,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.37-.215h175.297v29.88H.371z"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#booking_svg__g)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "booking_svg__h",
    width: 176,
    height: 31,
    x: 0,
    y: -1,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.37 29.666h175.297V-.215H.371z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#booking_svg__h)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#273B7D",
    d: "m8.356 19.556-3.725-.004V15.08c0-.957.37-1.454 1.185-1.568h2.54c1.813 0 2.985 1.149 2.986 3.007-.001 1.907-1.144 3.037-2.986 3.038M4.631 7.487V6.31c0-1.03.435-1.52 1.387-1.584h1.906c1.635 0 2.614.983 2.614 2.627 0 1.254-.67 2.717-2.554 2.717H4.631zm8.482 4.465-.673-.38.588-.505c.683-.59 1.83-1.918 1.83-4.211 0-3.51-2.71-5.775-6.904-5.775H3.168l-.545-.001A2.34 2.34 0 0 0 .37 3.398v19.92h2.196c.006.002.007 0 .01.002l5.471-.001c4.663 0 7.672-2.55 7.672-6.499 0-2.126-.972-3.943-2.607-4.868"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#499FDD",
    d: "M170.301 6.96a6.3 6.3 0 0 0-4.912 2.391l-.332.423-.26-.473c-.847-1.552-2.306-2.34-4.334-2.34-2.127 0-3.554 1.191-4.216 1.9l-.434.472-.167-.62c-.242-.894-1.033-1.386-2.232-1.386h-1.924l-.018 16.065h4.369V16.3c0-.62.077-1.236.232-1.878.418-1.714 1.564-3.557 3.491-3.372 1.188.114 1.769 1.036 1.769 2.818v9.524h4.4V16.3c0-.776.073-1.357.247-1.94.354-1.636 1.551-3.313 3.41-3.313 1.345 0 1.843.765 1.843 2.821v7.175c0 1.623.72 2.349 2.335 2.349h2.057l.003-10.256c0-4.097-1.794-6.176-5.327-6.176M130.542 17.814c-.013.016-1.894 2.008-4.369 2.008-2.256 0-4.535-1.39-4.535-4.494 0-2.68 1.767-4.553 4.296-4.553.821 0 1.756.296 1.902.793l.021.084c.337 1.127 1.357 1.187 1.557 1.187l2.394.003v-2.103c0-2.773-3.511-3.779-5.874-3.779-5.052 0-8.719 3.535-8.719 8.401s3.627 8.394 8.627 8.394c4.338 0 6.697-2.864 6.719-2.893l.126-.155-1.896-3.16z"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "booking_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h176v30H0z"
  })))));
};
export default SvgBooking;